<template>
    <a-card>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
        </a-table>
    </a-card>
</template>

<script>
import {activityApi} from "@/api/innovationService";
import {tableListMixin} from "@/mixins";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "活动名称", dataIndex: "activityName", key: "activityName"},
    {title: "企业名称", dataIndex: "unitName", key: "unitName"},
    {title: "联系人", dataIndex: "name", key: "name"},
    {title: "联系电话", dataIndex: "phone", key: "phone"},
    {title: "预计报名人数", dataIndex: "applyNum", key: "applyNum"},
    {title: "报名时间", dataIndex: "createdTime", key: "createdTime", customRender: defaultDateCustomRender},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
    },
    data() {
        return {
            columns,
            queryParamFixed: {
                companyCode:this.$ls.get("companyCode"),
                systemType: 'finance'
            },
            listKeyField: "id",
            listUrl:activityApi.pageList
        }
    },
    mounted() {
    },
    methods: {}
}
</script>

<style scoped>

</style>
